import "core-js/modules/web.dom-collections.iterator.js";
import classnames from 'classnames';
import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import '@eika/expand-list-card-style';
import toKebabCaseWithoutNorwegianCharacters from './utils/toKebabCaseWithoutNorwegianCharacters';
const H4 = _ref => {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("h4", {
    className: className
  }, children);
};
const ExpandListCardElement = _ref2 => {
  let {
    className,
    text,
    title,
    id,
    customHeaderLevelElement,
    isActive,
    dataTrackId
  } = _ref2;
  const Header = customHeaderLevelElement || H4;
  const [isExpanded, setIsExpanded] = useState(isActive);
  return /*#__PURE__*/React.createElement("section", {
    className: classnames('sgw-expand-list-card', className, {
      expanded: isExpanded
    }),
    "aria-labelledby": "expand-card-".concat(id)
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "sgw-expand-list-card__header",
    onClick: () => setIsExpanded(!isExpanded),
    "data-track-id": dataTrackId,
    "data-track-linkname": dataTrackId && toKebabCaseWithoutNorwegianCharacters(title),
    "data-track-open": dataTrackId && isExpanded
  }, /*#__PURE__*/React.createElement("div", {
    className: "sgw-expand-list-card__header-content"
  }, /*#__PURE__*/React.createElement(Header, {
    className: "sgw-expand-list-card__title-row"
  }, /*#__PURE__*/React.createElement("span", {
    id: "expand-card-".concat(id),
    className: "sgw-expand-list-card__title"
  }, title))), /*#__PURE__*/React.createElement("span", {
    className: "screen-reader-text"
  }, isExpanded ? 'Lukk' : ''), /*#__PURE__*/React.createElement("span", {
    className: classnames('sgw-expand-list-card__arrow', {
      active: isExpanded
    })
  })), /*#__PURE__*/React.createElement(AnimateHeight, {
    height: isExpanded ? 'auto' : 0,
    contentClassName: "sgw-expand-list-card__content"
  }, isExpanded && /*#__PURE__*/React.createElement("p", {
    className: "sgw-expand-list--card__text"
  }, text)));
};
export default ExpandListCardElement;